import React, { memo, useEffect, useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import { useMutation } from '@apollo/react-hooks'
import { OauthSender } from 'react-oauth-flow'
import queryString from 'query-string'
import { Loading } from 'components'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { GgLoginMutation, StoreValue } from 'store'
import { AuthStore } from '../../reducer'
import { ReactComponent as GoogleIcon } from 'assets/images/google.svg'
import { TGoogleProps, EAuthActionTypes, EAppStateActionTypes } from 'models'
import { GOOGLE_URIS } from 'utils'

const GoogleView = ({
	loading,
	toggle,
	redirect,
	dispatch,
	firebase: { instance: firebaseApp },
	storeDispatch,
}: TGoogleProps) => {
	const history = useHistory()
	const location = useLocation()
	const { i18n } = useTranslation()
	const [fetching, setFetching] = useState(false)
	const queryStringData = queryString.parse(location.search)
	const [GgLoginMutationHandle] = useMutation(GgLoginMutation)

	const googleLogin = (url: string) => () => {
		if (toggle) toggle(true)
		window.location.href = url
	}

	useEffect(() => {
		const fetchAccessCode = async () => {
			try {
				const { data }: any = await GgLoginMutationHandle({
					variables: {
						code: queryStringData.code,
					},
				})
				if (data && data.googleConnect) {
					await firebaseApp
						.auth()
						.signInWithCustomToken(data.googleConnect._ft)
						.then((firebaseUser: any) => {
							storeDispatch({
								type: EAppStateActionTypes.updateUser,
								user: data.googleConnect,
								firebaseUser,
							})
						})
						.catch((err: any) => {
							console.error(err)
						})
				} else {
					dispatch({
						type: EAuthActionTypes.authFailed,
					})
					history.replace(`/${i18n.language}/auth`)
				}
			} catch (error) {
				dispatch({
					type: EAuthActionTypes.authFailed,
				})
				history.replace(`/${i18n.language}/auth`)
			}
		}
		if (queryStringData.code && !fetching) {
			setFetching(true)
			fetchAccessCode()
		}
		// eslint-ignore-next-line
	}, [
		fetching,
		queryStringData,
		GgLoginMutationHandle,
		dispatch,
		history,
		i18n.language,
		storeDispatch,
		firebaseApp,
	])

	return redirect ? (
		<Loading size={48} />
	) : (
		<OauthSender
			authorizeUrl="https://accounts.google.com/o/oauth2/v2/auth"
			clientId="535912481384-nr7oniaqlv45e1ob8tm9189c7vorg3jo.apps.googleusercontent.com"
			// @ts-ignore
			redirectUri={GOOGLE_URIS[process.env.REACT_APP_ENVIRONMENT]}
			// state={{ language: i18n.language }}
			args={{
				scope:
					'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
			}}
			render={({ url }: { url: string }) => (
				<IconButton disabled={loading} onClick={googleLogin(url)}>
					<GoogleIcon />
				</IconButton>
			)}
		/>
	)
}

const GoogleViewWithAuthStore = (props: TGoogleProps) => (
	<AuthStore keys={['dispatch']}>
		<GoogleView {...props} />
	</AuthStore>
)
export default memo((props: TGoogleProps) => (
	<StoreValue keys={['firebase', 'storeDispatch']}>
		<GoogleViewWithAuthStore {...props} />
	</StoreValue>
))
